import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "../Assets/svgs/CloseIcon";
import { Loader } from "../Common/Loader";
import PlusIconBtn from "../Common/PlusIconBtn";
import ReactQuillEditor from "../Common/ReactQuillEditor";
import { getAssistantList } from "../Redux/Slice/Assistant/AssistantsListSlice";
import { scheduleInstantEmail } from "../Redux/Slice/Contacts/Email/ScheduleInstantEmailSlice";
import AddVariableModal from "./AddVariableModal";
import { scheduleCallAction } from "../Redux/Slice/Contacts/CallActionSlice";
import { scheduleFormCallAction } from "../Redux/Slice/Contacts/FormCallActionSlice";

const InstantEmailModal = ({
  closePopup,
  isForContactGroup,
  currentContact,
  assistantId,
  isMultiple,
  contactsList,
  isForCallId,
  isForForm,
}) => {
  const dispatch = useDispatch();
  const [assistants, setAssistants] = useState([]);
  const [selectedAssistant, setSelectedAssistant] = useState(assistantId ?? "");
  const AssistantList = useSelector((state) => state.assistants.assistantsList);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    subject: "",
    message: "",
  });
  const [formError, setFormError] = useState({
    subjectError: "",
    messageError: "",
  });
  const [addVariableModalVisible, setAddVariableModalVisible] = useState({
    variableFor: null,
    visible: false,
  });

  useEffect(() => {
    FetchAssistantsList();
  }, []);

  const FetchAssistantsList = async () => {
    await dispatch(getAssistantList({ text: "", isDropdown: true }));
  };
  useEffect(() => {
    if (AssistantList && Array.isArray(AssistantList.data)) {
      setAssistants(AssistantList.data);
      if (assistantId) {
        const currAssistant = AssistantList?.data?.find(
          (assistant) => assistant?.id == assistantId
        );
        setFormData((prev) => ({
          ...prev,
          subject: currAssistant?.email?.subject || "",
          message: currAssistant?.email?.description || "",
        }));
      }
    }
  }, [AssistantList]);

  const handleChangeAssistant = (e) => {
    const { value } = e?.target;
    const currAssistant = assistants?.find(
      (assistant) => assistant?.id == value
    );
    if (currAssistant) {
      setFormData((prev) => ({
        ...prev,
        subject: currAssistant?.email?.subject || "",
        message: currAssistant?.email?.description || "",
      }));
    }
    setSelectedAssistant(value);
  };

  const handleChange = async (e) => {
    let { name, value } = e.target;
    value = value.trimStart();
    if (name === "subject") {
      let capitalized = value.charAt(0).toString().toUpperCase();
      value = capitalized + value.substring(1);
      const isValid = !(value?.length < 3);
      if (isValid || value.trim() === "") {
        setFormError({ ...formError, subjectError: "" });
      } else {
        setFormError({
          ...formError,
          subjectError: "Subject must be between 3 and 100 characters long",
        });
      }
      setFormData({
        ...formData,
        subject: value,
      });
    } else if (name === "message") {
      let capitalized = value.charAt(0).toString().toUpperCase();
      value = capitalized + value.substring(1);
      const isValid = !(value?.length < 3);
      if (isValid || value.trim() === "") {
        setFormError({ ...formError, messageError: "" });
      } else {
        setFormError({
          ...formError,
          messageError: "Message must be between 3 and 100 characters long",
        });
      }
      setFormData({
        ...formData,
        message: value,
      });
    }
  };

  const onSubmitAddVariable = (variable) => {
    setFormData((p) => ({
      ...p,
      [addVariableModalVisible.variableFor]:
        p[addVariableModalVisible.variableFor] == "string"
          ? p[addVariableModalVisible.variableFor] + variable
          : variable,
    }));
    setAddVariableModalVisible({
      visible: false,
      variableFor: null,
    });
  };

  const handleSubmit = async () => {
    let body = {
      assistantId: selectedAssistant,
      subject: formData.subject,
      description: formData.message,
    };
    if (isForContactGroup) {
      body.contactGroupIds = isMultiple ? contactsList() : [currentContact?.id];
    } else if (isForCallId) {
      body.callId = isMultiple ? contactsList() : [currentContact?.id];
      body.action = "email";
    } else if (isForForm) {
      body.contacts = isMultiple ? contactsList() : [currentContact];
      body.action = "email";
    } else {
      body.contactIds = isMultiple ? contactsList() : [currentContact?.id];
    }
    setIsLoading(true);

    try {
      const action = isForCallId
        ? scheduleCallAction
        : isForForm
        ? scheduleFormCallAction
        : scheduleInstantEmail;
      const result = await dispatch(action(body));
      if (action.fulfilled.match(result) && result?.payload?.success === true) {
        closePopup("success");
        setIsLoading(false);
      } else {
        closePopup("error", result?.payload?.error);
        setIsLoading(false);
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  if (addVariableModalVisible?.visible) {
    return (
      <AddVariableModal
        assistantId={selectedAssistant}
        onSubmit={onSubmitAddVariable}
        onClose={() =>
          setAddVariableModalVisible({
            variableFor: null,
            visible: false,
          })
        }
      />
    );
  }

  return (
    <div className="modal modal--createAssistant modal--open">
      <div className="modal__dialog">
        <div className="modal__content modal__content--md">
          <div className="modal__header ">
            <h1 className="modal__header--title">Assign Assistant</h1>
            <p className="para">
              Please select the details below to assign assistant to your Email.
            </p>
            <button
              className="btn btn__transparent btnClose"
              onClick={closePopup}
            >
              <CloseIcon />
            </button>
          </div>
          <div className="modal__body  modal-body-left">
            <div className="scheduleCall">
              <div className="scheduleCall__row">
                <div className="form__Field form__Field--full">
                  <label for="assistant" className="form__label">
                    Assistant<sup className="form__label__asterisk">*</sup>
                  </label>
                  <select
                    className="form__select form__select--sm"
                    id="Chatbot"
                    name="chatbotId"
                    disabled={assistantId}
                    value={selectedAssistant}
                    onChange={handleChangeAssistant}
                  >
                    <option selected="" value="" disabled>
                      -Select-
                    </option>
                    {assistants
                      ? assistants.map((assistant) => (
                          <option value={assistant.id}>{assistant.name}</option>
                        ))
                      : ""}
                  </select>
                </div>
                <div className="formCol">
                  <div className="form__Field form__Field--full">
                    <label
                      for="subject"
                      className="form__label form__label--flex"
                    >
                      <span>
                        Subject<sup className="form__label__asterisk">*</sup>
                      </span>
                      {selectedAssistant ? (
                        <PlusIconBtn
                          onClick={() =>
                            setAddVariableModalVisible({
                              variableFor: "subject",
                              visible: true,
                            })
                          }
                        />
                      ) : null}
                    </label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      className="form__input form__input--sm"
                      placeholder="Subject"
                      maxLength={100}
                    />
                  </div>
                  <div className="form__error">{formError.subjectError}</div>
                </div>
              </div>
              <div className="scheduleCall__row">
                <div className="form__Field form__Field--full">
                  <label
                    for="message"
                    className="form__label form__label--flex"
                  >
                    <span>
                      Message<sup className="form__label__asterisk">*</sup>
                    </span>
                    {selectedAssistant ? (
                      <PlusIconBtn
                        onClick={() =>
                          setAddVariableModalVisible({
                            variableFor: "message",
                            visible: true,
                          })
                        }
                      />
                    ) : null}
                  </label>
                  <ReactQuillEditor
                    id="message"
                    name="message"
                    theme="snow"
                    value={formData.message}
                    style={{ width: "100%" }}
                    placeholder="Enter your message here..."
                    onChange={(value) =>
                      setFormData((prev) => ({
                        ...prev,
                        message: value,
                      }))
                    }
                  />
                </div>
                <div className="form__error">{formError.messageError}</div>
              </div>
            </div>
          </div>
          <div className="modal__footer">
            <div className="btn__group">
              <button className="btn btn__white" onClick={closePopup}>
                Cancel
              </button>
              <button
                disabled={
                  !selectedAssistant ||
                  !formData.message ||
                  formData?.message?.replace(/<(.|\n)*?>/g, "").trim()
                    .length === 0 ||
                  !formData.subject ||
                  formError.messageError ||
                  formError.subjectError
                }
                className="btn btn__primary"
                onClick={handleSubmit}
              >
                Send
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal__backdrop"></div>
    </div>
  );
};

export default InstantEmailModal;
